export var CartInformationInitial = {
    account: {
        email: "",
    },
    billing: {
        firstName: "",
        lastName: "",
        streetName: "",
        streetNumber: "",
        city: "",
        country: "",
        postalCode: "",
    },
    shipping: {
        firstName: "",
        lastName: "",
        streetName: "",
        streetNumber: "",
        city: "",
        country: "",
        postalCode: "",
    },
};
